export const ADD_FIELD = 'add_field'
export const CHANGE_DEFAULT_VALUE = 'change_default_value'
export const CHANGE_NAME = 'change_name'
export const CHANGE_NULLABLE = 'change_nullable'
export const CHANGE_TYPE = 'change_type'
export const REMOVE_FIELD = 'remove_field'
